// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2qeGi","title":"FrontImage_title__3Hay0"};